









import Vue from 'vue';
import { notifyDialog } from './Notify';


export default Vue.extend({
  data: () => notifyDialog,
  watch: {
    visible(value) {
      if (!value) {
        this.handle(false);
      }
    },
  },
});
